import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 8"
      portada="https://fullcomics18.org/img10/touchuukasou8-1.jpg"
    paginas={[
  "https://fullcomics18.org/img10/touchuukasou8-1.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-2.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-3.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-4.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-5.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-6.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-7.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-8.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-9.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-10.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-11.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-12.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-13.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-14.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-15.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-16.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-17.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-18.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-19.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-20.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-21.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-22.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-23.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-24.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-25.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-26.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-27.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-28.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-29.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-30.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-31.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-32.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-33.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-34.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-35.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-36.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-37.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-38.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-39.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-40.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-41.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-42.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-43.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-44.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-45.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-46.jpg",
  "https://fullcomics18.org/img10/touchuukasou8-47.jpg"
]}
      sugeridos={[]}


      info={{
     grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Anal", "Beauty Mark", "Big Breasts", "Closed Eyes", "Digital", "FFM Threesome", "Freckles", "Group", "Multi-work Series", "Netorare", "Sex Toys", "Shaved Head", "Shimaidon"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 8",
  portada: "https://fullcomics18.org/img10/touchuukasou8-1.jpg",
  reverso: "https://fullcomics18.org/img10/touchuukasou8-3.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Anal", "Beauty Mark", "Big Breasts", "Closed Eyes", "Digital", "FFM Threesome", "Freckles", "Group", "Multi-work Series", "Netorare", "Sex Toys", "Shaved Head", "Shimaidon"],
    artistas: "Fuetakishi",
  },
};
